import { reducer as formReducer } from "redux-form/immutable";

import { ACTIONS, GROUP_FORM } from "features/planner/planner.constants";

const groupFormReducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.RESET_GROUP_FORM_FACILITY:
      return state
        .setIn(["asyncErrors", GROUP_FORM.FACILITY_ID], "Invalid")
        .setIn(["values", GROUP_FORM.FACILITY_ID], null);

    default:
      return state;
  }
};

export default formReducer.plugin({
  [GROUP_FORM.ID]: groupFormReducer,
});
